export default __webpack_public_path__ + "static/media/wrong_foods@3x.dc70a7f8.jpg";